import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useConsultaRefc = ({ dadosOs }) => {
  const { cnpjCpf, inscricaoEstadual } = dadosOs;
  const { request, data, error } = useApiClient();
  const [ocorrencias, setOcorrencias] = useState({});

  useEffect(() => {
    let ie = "";
    if (inscricaoEstadual !== "" || inscricaoEstadual !== undefined) {
      ie = inscricaoEstadual;
    } else if (cnpjCpf !== "" || cnpjCpf !== undefined) {
      ie = cnpjCpf;
    }

    request(apiRoutes.fiscalizacao.ordemservico.listarOcorrenciasRefc, { ie });
  }, [cnpjCpf, inscricaoEstadual, request]);

  useEffect(() => {
    if (data?.result) {
      setOcorrencias(data.result);
    }
    if (error) {
      toast.error(error.message);
    }
  }, [data, error]);

  const { request: requestDownload, data: dataDownload, errors: errorDownload } = useApiClient();
  const handleImprimirRelatorio = useCallback(
    (ie, razaoSocial, cnpj) => {
      requestDownload(apiRoutes.fiscalizacao.ordemservico.imprimirOcorrenciasRefc, { ie, razaoSocial, cnpj });
    },
    [requestDownload],
  );

  const handleDownload = useCallback(() => {
    if (dataDownload) {
      const file = new Blob([dataDownload], { type: "application/pdf" });

      setTimeout(() => {
        const url = URL?.createObjectURL(file);
        window.open(url, "_blank", "width=800,height=800").print();
      }, 1000);
    }
    if (errorDownload) {
      toast.error(errorDownload.message);
    }
  }, [dataDownload, errorDownload]);

  useEffect(() => {
    handleDownload();
  }, [handleDownload]);

  return {
    ocorrencias,
    handleImprimirRelatorio,
  };
};
export default useConsultaRefc;
